enum Roles {
  Basic = 'basic',
  Admin = 'admin',
  GuestVUV = 'GuestVUV',
}
export default Roles;
